// extracted by mini-css-extract-plugin
export default {"EmptyPanel":"EmptyPanel_EmptyPanel__auDhZ","EmptyPanel__Icon":"EmptyPanel_EmptyPanel__Icon__ASnQZ"};